export default __webpack_public_path__ + "static/media/promission-contact.91aed653.png";